import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { ProductOpt } from './productopt';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ProductOptType } from '../types';
import { PriceZoneType } from '../types';
import { PriceTimeType } from '../types';

const _schema = {
    name: 'OPTIONPRICE',
    fields: [
        { name: 'status', type: 'string', default: 'AC' },
        { name: 'productopt', type: 'objid' },
        { name: 'pricezone', type: 'objid' },
        { name: 'pricetime', type: 'objid' },
        { name: 'price', type: 'number' },
    ],
    relate: [
        { direction: '>', target: 'PRODUCTOPT', by: 'productopt', name: 'productopt', reason: 'productopt', child: false, class: ProductOptType },
        { direction: '>', target: 'PRICEZONE', by: 'pricezone', name: 'pricezone', reason: 'pricezone', child: false, class: PriceZoneType },
        { direction: '>', target: 'PRICETIME', by: 'pricetime', name: 'pricetime', reason: 'pricetime', child: false, class: PriceTimeType },
    ]
} as const;

const _OptionPriceClass = CreateObject(_schema);
if (!_OptionPriceClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class OptionPrice extends _OptionPriceClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): OptionPrice {
        return this._Copy(store) as OptionPrice;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'productopt' && related instanceof ProductOpt){
            if (related === this.productopt){
                related.AddPrice(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.productopt){
            if ((this.status == 'DE') && !this.Commited){
                this.productopt.DelPrice(this);
            }
            else {
                this.productopt.DoRefresh(this.table);
            }
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
